var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgConferenceTabActive = function SvgConferenceTabActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35664 0.637742C2.57534 0.419343 2.83795 0.249922 3.12707 0.140707C3.41619 0.0314914 3.72521 -0.0150244 4.03367 0.00424171C4.34212 0.0235079 4.64296 0.108116 4.91625 0.252459C5.18953 0.396803 5.42903 0.597585 5.61886 0.841502L7.86242 3.72413C8.27363 4.25291 8.41862 4.94169 8.25613 5.59172L7.57244 8.32934C7.53709 8.47114 7.539 8.61966 7.57799 8.7605C7.61697 8.90134 7.6917 9.0297 7.79492 9.13313L10.8659 12.2045C10.9694 12.308 11.098 12.3828 11.2391 12.4218C11.3801 12.4608 11.5289 12.4626 11.6708 12.427L14.4069 11.7433C14.7276 11.663 15.0624 11.6568 15.3859 11.725C15.7094 11.7933 16.0131 11.9341 16.2742 12.137L19.1565 14.3796C20.1926 15.1859 20.2876 16.7172 19.3602 17.6435L18.0678 18.9361C17.1429 19.8611 15.7605 20.2674 14.4719 19.8136C11.1736 18.653 8.17898 16.7645 5.7101 14.2884C3.23442 11.8195 1.34623 8.82494 0.185573 5.52672C-0.266889 4.23916 0.139327 2.85534 1.06425 1.9303L2.35664 0.637742Z",
    fill: "#CECFD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H16V4H12V6ZM16 6H20V4H16V6ZM17 5V1H15V5H17ZM15 1V9H17V1H15Z",
    fill: "#CECFD5"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConferenceTabActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ConferenceTabActive.80a7dcbf.svg";
export { ForwardRef as ReactComponent };